import '@hotwired/turbo-rails';
import { initDiagrams } from '~/lib/diagram_renderer';
import { runMermaid } from '~/lib/mermaid';
import { initPublicAnalytics, trackPublicAnalyticsPageView } from '~/lib/public_analytics';
import { initPublicDiagrams } from '~/lib/public_diagrams';
import { initPublicMobileMenu } from '~/lib/public_mobile_menu';
import { initPublicPasswordVisibility } from '~/lib/public_password_visibility';
import { initPublicProductStory } from '~/lib/public_product_story';
import { initPublicWaitlistModal } from '~/lib/publicWaitlistModal';
import { initPublicCopyText } from '~/lib/public_copy_text';
import { initPublicHelpSearch } from '~/lib/public_help_search';
import { initPublicPricing } from '~/lib/publicPricing';
import { initializeSentry } from '~/lib/sentry';

// Run on initial load
document.addEventListener('DOMContentLoaded', () => {
  initializeSentry({ surface: 'public' });
  initPublicMobileMenu();
  initPublicPasswordVisibility();
  initPublicProductStory();
  initPublicWaitlistModal();
  initPublicCopyText();
  initPublicHelpSearch();
  initPublicPricing();
  initPublicAnalytics();
  runMermaid();
  initDiagrams();
  initPublicDiagrams();
});

// Run on turbo navigations
document.addEventListener('turbo:load', () => {
  initPublicMobileMenu();
  initPublicPasswordVisibility();
  initPublicProductStory();
  initPublicWaitlistModal();
  initPublicCopyText();
  initPublicPricing();
  initPublicAnalytics();
  trackPublicAnalyticsPageView();
  runMermaid();
  initDiagrams();
  initPublicDiagrams();
});
